import { render, staticRenderFns } from "./VerificationMethod.vue?vue&type=template&id=32ccd34c"
import script from "./VerificationMethod.vue?vue&type=script&lang=js"
export * from "./VerificationMethod.vue?vue&type=script&lang=js"
import style0 from "./VerificationMethod.vue?vue&type=style&index=0&id=32ccd34c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports